import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { BaseService } from 'src/app/_services/base.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PayoutReportService {

    constructor(private _bs: BaseService) { }

    /**
     * Sales / payout report from the Order service (order-svc/api/Invoice/GetSalesReport).
     * `payload` carries the report filters (dates, LocationIds, customer search, paging).
     */
    getSalesReport(payload: any) {
        const url = environment.OrderBaseURL + 'Invoice/GetSalesReport';
        return this._bs.httpPost(url, JSON.stringify(payload)).pipe(map((res: any) => res));
    }
}
